module.exports = __webpack_public_path__ + "static/media/9.3932b560.mp3";